import React from "react";

const COLUMNS = [
  { id: "backlog", title: "Backlog", dbValue: "Backlog" },
  { id: "todo", title: "To Do", dbValue: "To Do" },
  { id: "inprogress", title: "In Progress", dbValue: "In Progress" },
  { id: "review", title: "Review", dbValue: "Review" },
  { id: "done", title: "Done", dbValue: "Done" }
];

const PROJECT_TYPES = [
  { id: "grouped", title: "Grouped", dbValue: "Grouped" },
  { id: "personal", title: "Personal", dbValue: "Personal" }
];

function ProjectModal({ 
  isOpen, 
  editingProject, 
  formData, 
  setFormData, 
  clients = [], 
  systemUsers = [],   
  isSuperAdmin = false, 
  onSave, 
  onClose 
}) {
  if (!isOpen) return null;

  // Multi-user assignment change toggle processor
  const handleUserToggle = (userId) => {
    const currentSelections = formData.assigned_user_ids || [];
    let updatedSelections;

    if (currentSelections.includes(userId)) {
      updatedSelections = currentSelections.filter((id) => id !== userId);
    } else {
      updatedSelections = [...currentSelections, userId];
    }

    setFormData({
      ...formData,
      assigned_user_ids: updatedSelections
    });
  };

  // Validation state checking
  const isFormInvalid = !formData.project_name || (!formData.meta_id && (!formData.new_client_name || !formData.new_client_name.trim()));

  return (
    <div className="modal-overlay" style={styles.overlay}>
      <div className="modal-box" style={styles.modalBox}>
        <h3 style={{ marginTop: 0, marginBottom: "15px" }}>
          {editingProject ? "Edit Project" : "Add Project"}
        </h3>

        {/* --- CLIENT & ASSIGNMENT SECTION --- */}
        <label style={styles.label}>Link Client Profile</label>
        <select
          value={formData.meta_id || ""}
          onChange={(e) => {
            const selectedVal = e.target.value;
            setFormData({ 
              ...formData, 
              meta_id: selectedVal,
              new_client_name: selectedVal ? "" : formData.new_client_name
            });
          }}
          style={styles.select}
          disabled={!isSuperAdmin || (formData.new_client_name && formData.new_client_name.trim() !== "")}
        >
          <option value="">-- Select Main Client --</option>
          {clients.map((client) => (
            <option key={client.meta_id} value={client.meta_id}>
              {client.client_name}
            </option>
          ))}
        </select>

        {isSuperAdmin && (
          <>
            <label style={styles.label}>Or Add a Brand New Client</label>
            <input
              type="text"
              placeholder="Type new client name to auto-create..."
              value={formData.new_client_name || ""}
              onChange={(e) => {
                const typedVal = e.target.value;
                setFormData({ 
                  ...formData, 
                  new_client_name: typedVal,
                  meta_id: typedVal.trim() !== "" ? "" : formData.meta_id
                });
              }}
              style={styles.input}
              disabled={!!formData.meta_id}
            />
          </>
        )}

        {/* --- MULTI-USER SELECTION LIST --- */}
        {isSuperAdmin && (
          <>
            <label style={styles.label}>Assign Project to Users (Select Multiple)</label>
            <div style={styles.checkboxContainer}>
              {systemUsers.length === 0 ? (
                <div style={{ color: "#888", fontSize: "12px", padding: "5px" }}>No users available</div>
              ) : (
                systemUsers.map((user) => {
                  const isChecked = (formData.assigned_user_ids || []).includes(user.id);
                  return (
                    <label key={user.id} style={styles.checkboxLabel}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleUserToggle(user.id)}
                        style={styles.checkboxInput}
                      />
                      <span style={{ fontSize: "13px", color: isChecked ? "#1e40af" : "#374151", fontWeight: isChecked ? "600" : "normal" }}>
                        {user.name || user.email}
                      </span>
                    </label>
                  );
                })
              )}
            </div>
          </>
        )}

        {/* --- CORE DETAILS SECTION --- */}
        <h4 style={styles.sectionHeader}>Core Details</h4>
        
        <label style={styles.label}>Project Name</label>
        <input
          type="text"
          placeholder="e.g., Reliance DC Mumbai"
          value={formData.project_name || ""}
          onChange={(e) => setFormData({ ...formData, project_name: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Project Code</label>
        <input
          type="text"
          placeholder="e.g., REL001"
          value={formData.project_code || ""}
          onChange={(e) => setFormData({ ...formData, project_code: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Location</label>
        <input
          type="text"
          placeholder="Location Details"
          value={formData.location || ""}
          onChange={(e) => setFormData({ ...formData, location: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        {/* --- FIELD & ACTIVITY METRICS SECTION --- */}
        <h4 style={styles.sectionHeader}>Field Tracking Metrics</h4>

        <label style={styles.label}>KM (Distance/Chainage)</label>
        <input
          type="text"
          placeholder="e.g., 12.5 KM"
          value={formData.km || ""}
          onChange={(e) => setFormData({ ...formData, km: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Office Lead</label>
        <input
          type="text"
          placeholder="Office manager name"
          value={formData.office_lead || ""}
          onChange={(e) => setFormData({ ...formData, office_lead: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Site Lead</label>
        <input
          type="text"
          placeholder="On-site team lead name"
          value={formData.site_lead || ""}
          onChange={(e) => setFormData({ ...formData, site_lead: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        {/* MODIFIED: Field Activity Start changed to native calendar input */}
        <label style={styles.label}>Field Activity Start (Project Start Date)</label>
        <input
          type="date"
          value={formData.field_activity || ""}
          onChange={(e) => setFormData({ ...formData, field_activity: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        {/* MODIFIED: Field Activity End changed to native calendar input */}
        <label style={styles.label}>Field Activity End (Project Close Date)</label>
        <input
          type="date"
          value={formData.field_activity_end || ""}
          onChange={(e) => setFormData({ ...formData, field_activity_end: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>KML File Info</label>
        <input
          type="text"
          placeholder="Link or tracking ID for KML mapping"
          value={formData.kml || ""}
          onChange={(e) => setFormData({ ...formData, kml: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Report Code/Link</label>
        <input
          type="text"
          placeholder="e.g., Draft Report v1"
          value={formData.report || ""}
          onChange={(e) => setFormData({ ...formData, report: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Submission Status</label>
        <input
          type="text"
          placeholder="e.g., Submitted to Client / Pending Approval"
          value={formData.submission || ""}
          onChange={(e) => setFormData({ ...formData, submission: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        <label style={styles.label}>Bill/Invoice Details</label>
        <input
          type="text"
          placeholder="e.g., Inv-2024-001 or Paid"
          value={formData.bill || ""}
          onChange={(e) => setFormData({ ...formData, bill: e.target.value })}
          style={styles.input}
          disabled={!isSuperAdmin}
        />

        {/* --- CLASSIFICATION SECTION --- */}
        <h4 style={styles.sectionHeader}>Classification & Status</h4>

        <label style={styles.label}>Project Type Classification</label>
        <select
          value={formData.project_type || ""}
          onChange={(e) => setFormData({ ...formData, project_type: e.target.value })}
          style={styles.select}
          disabled={!isSuperAdmin}
        >
          <option value="" disabled>-- Select Allocation Type --</option>
          {PROJECT_TYPES.map((type) => (
            <option key={type.id} value={type.dbValue}>
              {type.title} Workflow
            </option>
          ))}
        </select>

        <label style={styles.label}>Project Status</label>
        <select
          value={formData.status || ""} 
          onChange={(e) => setFormData({ ...formData, status: e.target.value })}
          style={styles.select}
          disabled={!isSuperAdmin}
        >
          <option value="" disabled>-- Select Current Status --</option>
          {COLUMNS.map((c) => (
            <option key={c.id} value={c.dbValue}>
              {c.title}
            </option>
          ))}
        </select>

        {/* ACTION BUTTONS */}
        <div style={styles.actionStickyBar}>
          {isSuperAdmin && (
            <button 
              onClick={onSave} 
              disabled={isFormInvalid}
              style={{
                ...styles.saveButton,
                ...(isFormInvalid ? { backgroundColor: "#93c5fd", cursor: "not-allowed" } : {})
              }}
            >
              {editingProject ? "Update Project" : "Create Project"}
            </button>
          )}
          <button onClick={onClose} style={styles.cancelButton}>
            {isSuperAdmin ? "Cancel" : "Close View"}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1100 },
  modalBox: { background: "#fff", padding: "25px 25px 5px 25px", borderRadius: "12px", width: "450px", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)", boxSizing: "border-box" },
  sectionHeader: { margin: "20px 0 10px 0", paddingBottom: "5px", borderBottom: "1px solid #e5e7eb", color: "#1f2937", fontSize: "14px", fontWeight: "600" },
  label: { display: "block", fontSize: "12px", fontWeight: "bold", color: "#4b5563", marginBottom: "4px", marginTop: "12px" },
  input: { width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #d1d5db", boxSizing: "border-box", marginBottom: "8px" },
  select: { width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #d1d5db", backgroundColor: "#fff", boxSizing: "border-box", marginBottom: "8px" },
  
  checkboxContainer: { 
    maxHeight: "120px", 
    overflowY: "auto", 
    border: "1px solid #d1d5db", 
    borderRadius: "6px", 
    padding: "8px", 
    backgroundColor: "#f9fafb",
    marginBottom: "8px"
  },
  checkboxLabel: { 
    display: "flex", 
    alignItems: "center", 
    marginBottom: "6px", 
    cursor: "pointer" 
  },
  checkboxInput: { 
    marginRight: "8px",
    cursor: "pointer",
    width: "16px",
    height: "16px"
  },

  actionStickyBar: { 
    marginTop: "24px", 
    display: "flex", 
    gap: "10px", 
    position: "sticky", 
    bottom: 0, 
    background: "#fff", 
    padding: "15px 0 15px 0", 
    borderTop: "1px solid #f3f4f6" 
  },
  saveButton: { flex: 1, padding: "12px", background: "#2563eb", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", transition: "background-color 0.2s ease" },
  cancelButton: { flex: 1, padding: "12px", background: "#e5e7eb", color: "#374151", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "bold", textAlign: "center" }
};

export default ProjectModal;